import * as types from '../../action-types';
import {getSingleEmployment as initialState } from "../../initialState";

const getSingleEmployment = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_EMPLOYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_EMPLOYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_EMPLOYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSingleEmployment;
